module.exports = __webpack_public_path__ + "img/88c86af0d863c34241c2b9aaa9184341.png";